const toClassNames = (...args) =>
    (args.filter(el => !!el && typeof el === 'string')).join(' ')

export {
    toClassNames
}